<template>
    <el-form ref="form" label-position="top">
        <el-row :gutter="25">
            <el-col :lg="12">
                <el-form-item class="el-form-item-full" :label="$l('settings/delete/autoDelete')">
                    <el-select v-model="getSettingsSystem.deletedays" :placeholder="$l('common/select')">
                        <el-option :label="$l('settings/delete/Disable')" value="0"></el-option>
                        <el-option :label="'1 ' + $l('settings/delete/week')" value="7 days"></el-option>
                        <el-option :label="'2 ' + $l('settings/delete/week')" value="14 days"></el-option>
                        <el-option :label="'1 ' + $l('settings/delete/month')" value="1 month"></el-option>
                        <el-option :label="'2 ' + $l('settings/delete/month')" value="2 month"></el-option>
                        <el-option :label="'6 ' + $l('settings/delete/month')" value="6 month"></el-option>
                        <el-option :label="'12 ' + $l('settings/delete/month')" value="1 year"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            
            <el-col :lg="12">
                <el-form-item class="el-form-item-full" :label="$l('settings/delete/Manual delete')">
                    <el-row>                       
                        <el-col :span="11">
                            <el-date-picker v-model="form.ManualDelete.From" style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-date-picker v-model="form.ManualDelete.To" style="width: 100%;"></el-date-picker>
                        </el-col>
                    </el-row>
                </el-form-item>
            </el-col>
             <el-col :lg="12">
                <el-form-item class="el-form-item-full" :label="$l('settings/delete/autoCompress')">
                    <el-select v-model="getSettingsSystem.compressdays" :placeholder="$l('common/select')">
                        <el-option :label="$l('settings/delete/Disable')" value="0"></el-option>
                        <el-option :label="'1 ' + $l('settings/delete/week')" value="7 days"></el-option>
                        <el-option :label="'2 ' + $l('settings/delete/week')" value="14 days"></el-option>
                        <el-option :label="'1 ' + $l('settings/delete/month')" value="1 month"></el-option>
                        <el-option :label="'2 ' + $l('settings/delete/month')" value="2 month"></el-option>
                        <el-option :label="'6 ' + $l('settings/delete/month')" value="6 month"></el-option>
                        <el-option :label="'12 ' + $l('settings/delete/month')" value="1 year"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item class="el-form-item-full">
                    <el-button :loading="deleteLoading" style="float:right" type="primary" @click="onSubmit">{{$l('settings/delete/Delete')}}</el-button>
                </el-form-item>
            </el-col>
        </el-row>
        
        <el-collapse accordion>
            <el-collapse-item :title="$l('settings/delete/Values')">
                <el-row>
                    <el-col v-for="item in getSettingsSystem.delvalsel" v-bind:key="item.name" :md="12" :lg="8">
                        <el-form-item class="el-form-item-full" v-show="!(item.name == 'logs' && !getSettingsAddons.logs)" :label="$l('settings/delete/' + item.name)">
                            <el-switch on-text="" off-text="" v-model="item.enabled"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-collapse-item>
        </el-collapse>
    </el-form>
    
</template>

<style>

</style>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return {
            deleteLoading: false,
            form: {
                AutoDelete:'',
                ManualDelete:{
                    From:new Date(),
                    To:new Date() ,
                    Range: [new Date(), new Date()],
                },
                Values:{
                    Measurements:false,
                    Audio:false,
                    Weather:false,
                    IntegralValues:false,
                    Logs:false,
                    Statistics:false,
                    ADIO:false
                }
            }
        }
    },
    computed:{
        ...mapGetters([
            'getSettingsSystem',
            'getSettingsAddons'
        ])
    },
    methods: {
        ...mapActions([
            'deleteOnInterval'
        ]),
        onSubmit() {
            this.deleteLoading = true;
            setTimeout(()=>{
                let values = this.getSettingsSystem.delvalsel.filter(val=>val.enabled).map(val=>val.name).join(',');
                this.deleteOnInterval({
                    From:this.form.ManualDelete.From,
                    To:this.form.ManualDelete.To,
                    Values:values
                });
                this.deleteLoading = false;
            },1500);
        }
    }
}
</script>


// WEBPACK FOOTER //
// Delete.vue?1f155eeb